import { object, string } from "yup";

export const getValidationSchema = (t) =>
  object().shape({
    firstName: string()
      .min(2, t("personalInfo.validation.nameMin"))
      .max(100, t("personalInfo.validation.nameMax"))
      .required(t("personalInfo.validation.firstNameRequired")),
    lastName: string()
      .min(2, t("personalInfo.validation.nameMin"))
      .max(100, t("personalInfo.validation.nameMax"))
      .required(t("personalInfo.validation.lastNameRequired")),
    dob: string()
      .min(8, t("personalInfo.validation.dobFormat"))
      .required(t("personalInfo.validation.dobRequired")),
    email: string().required(t("personalInfo.validation.emailRequired")),
    ssn: string()
      .min(9, t("personalInfo.validation.ssnLength"))
      .required(t("personalInfo.validation.ssnRequired")),
    physicalAddress1: string()
      .min(2, t("personalInfo.validation.minChars"))
      .required(t("personalInfo.validation.physicalAddressRequired")),
    physicalCity: string()
      .min(2, t("personalInfo.validation.minChars"))
      .required(t("personalInfo.validation.physicalCityRequired")),
    physicalState: string()
      .max(2, t("personalInfo.validation.stateIdentifier"))
      .required(t("personalInfo.validation.physicalStateRequired"))
      .matches(
        /^([A-Za-zÀ-ÖØ-öø-ÿ\s]*)$/gi,
        t("personalInfo.validation.stateLettersOnly")
      ),
    physicalZip: string()
      .min(5, t("personalInfo.validation.zipMin"))
      .required(t("personalInfo.validation.physicalZipRequired")),
  });

export const getPersonalInfoInputs = (t) => [
  {
    name: "firstName",
    label: t("personalInfo.fields.firstName.label"),
    type: "text",
    placeholder: t("personalInfo.fields.firstName.placeholder"),
  },
  {
    name: "lastName",
    label: t("personalInfo.fields.lastName.label"),
    type: "text",
    placeholder: t("personalInfo.fields.lastName.placeholder"),
  },
  {
    name: "dob",
    label: t("personalInfo.fields.dob.label"),
    type: "text",
    placeholder: t("personalInfo.fields.dob.placeholder"),
  },
  {
    name: "email",
    label: t("personalInfo.fields.email.label"),
    type: "text",
    placeholder: t("personalInfo.fields.email.placeholder"),
    prependIcon: "@",
  },
  {
    name: "ssn",
    label: t("personalInfo.fields.ssn.label"),
    type: "text",
    placeholder: "#########",
  },
  {
    name: "phoneNumber",
    label: t("personalInfo.fields.phoneNumber.label"),
    type: "text",
    placeholder: "########",
  },
];

export const getPhysicalAddressInputs = (t) => [
  {
    name: "physicalAddress1",
    label: t("personalInfo.fields.physicalAddress1.label"),
    type: "text",
    placeholder: t("personalInfo.fields.physicalAddress1.placeholder"),
  },
  {
    name: "physicalAddress2",
    label: t("personalInfo.fields.physicalAddress2.label"),
    type: "text",
    placeholder: t("personalInfo.fields.physicalAddress2.placeholder"),
  },
  {
    name: "physicalCity",
    label: t("personalInfo.fields.physicalCity.label"),
    type: "text",
    placeholder: t("personalInfo.fields.physicalCity.placeholder"),
  },
  {
    name: "physicalState",
    label: t("personalInfo.fields.physicalState.label"),
    type: "text",
    placeholder: t("personalInfo.fields.physicalState.placeholder"),
  },
  {
    name: "physicalZip",
    label: t("personalInfo.fields.physicalZip.label"),
    type: "text",
    placeholder: t("personalInfo.fields.physicalZip.placeholder"),
  },
];

export const getMailingAddressInputs = (t) => [
  {
    name: "mailingAddress1",
    label: t("personalInfo.fields.mailingAddress1.label"),
    type: "text",
    placeholder: t("personalInfo.fields.mailingAddress1.placeholder"),
  },
  {
    name: "mailingAddress2",
    label: t("personalInfo.fields.mailingAddress2.label"),
    type: "text",
    placeholder: t("personalInfo.fields.mailingAddress2.placeholder"),
  },
  {
    name: "mailingCity",
    label: t("personalInfo.fields.mailingCity.label"),
    type: "text",
    placeholder: t("personalInfo.fields.mailingCity.placeholder"),
  },
  {
    name: "mailingState",
    label: t("personalInfo.fields.mailingState.label"),
    type: "text",
    placeholder: t("personalInfo.fields.mailingState.placeholder"),
  },
  {
    name: "mailingZip",
    label: t("personalInfo.fields.mailingZip.label"),
    type: "text",
    placeholder: t("personalInfo.fields.mailingZip.placeholder"),
  },
];
